import React from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { criticalityOptions, supervisorOptions, technicianOptions } from '../data/assetsMockData';

const AssetFilters = ({ filters, onFilterChange }) => {
  const selectSx = {
    fontSize: '0.875rem',
    bgcolor: '#fff',
    borderRadius: 2,
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E5E7EB' },
    '& .MuiSelect-select': { py: 1.25, px: 1.5 },
  };

  const numberInputSx = {
    width: 100,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      bgcolor: '#fff',
      '& fieldset': { borderColor: '#E5E7EB' },
    },
    '& .MuiOutlinedInput-input': { py: 1.25, px: 1.5, fontSize: '0.875rem' },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2.5,
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        p: 2.5,
        bgcolor: '#fff',
        borderRadius: 1,
        border: '1px solid #E5E7EB',
      }}
    >
      {/* Criticality */}
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <Typography variant="body2" sx={{ mb: 0.75, fontWeight: 500, color: 'text.secondary', fontSize: '0.75rem' }}>
          Criticality
        </Typography>
        <Select
          value={filters.criticality}
          onChange={(e) => onFilterChange('criticality', e.target.value)}
          fullWidth
          size="small"
          sx={selectSx}
        >
          {criticalityOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </Select>
      </Box>

      {/* Supervisors */}
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <Typography variant="body2" sx={{ mb: 0.75, fontWeight: 500, color: 'text.secondary', fontSize: '0.75rem' }}>
          Supervisors
        </Typography>
        <Select
          value={filters.supervisor}
          onChange={(e) => onFilterChange('supervisor', e.target.value)}
          fullWidth
          size="small"
          sx={selectSx}
        >
          {supervisorOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </Select>
      </Box>

      {/* Technicians */}
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <Typography variant="body2" sx={{ mb: 0.75, fontWeight: 500, color: 'text.secondary', fontSize: '0.75rem' }}>
          Technicians
        </Typography>
        <Select
          value={filters.technician}
          onChange={(e) => onFilterChange('technician', e.target.value)}
          fullWidth
          size="small"
          sx={selectSx}
        >
          {technicianOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </Select>
      </Box>

      {/* Confidence% */}
      <Box sx={{ minWidth: 100 }}>
        <Typography variant="body2" sx={{ mb: 0.75, fontWeight: 500, color: 'text.secondary', fontSize: '0.75rem' }}>
          Confidence% &gt;=
        </Typography>
        <TextField
          type="number"
          value={filters.confidence}
          onChange={(e) => onFilterChange('confidence', e.target.value)}
          size="small"
          sx={numberInputSx}
          InputProps={{
            inputProps: { min: 0, max: 100 },
          }}
        />
      </Box>

      {/* RUL% */}
      <Box sx={{ minWidth: 100 }}>
        <Typography variant="body2" sx={{ mb: 0.75, fontWeight: 500, color: 'text.secondary', fontSize: '0.75rem' }}>
          RUL% &gt;=
        </Typography>
        <TextField
          type="number"
          value={filters.rulPercent}
          onChange={(e) => onFilterChange('rulPercent', e.target.value)}
          size="small"
          sx={numberInputSx}
          InputProps={{
            inputProps: { min: 0, max: 100 },
          }}
        />
      </Box>
    </Box>
  );
};

export default AssetFilters;
